var _circle, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEnvelope = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 612 624"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 306,
  cy: 306,
  r: 306,
  fill: "#E4E9ED"
})), /*#__PURE__*/React.createElement("mask", {
  id: "envelope_svg__a",
  width: 612,
  height: 612,
  x: 0,
  y: 12,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#C6365B",
  d: "M611.999 317.952c0 168.847-136.895 305.724-305.762 305.724S.477 486.799.477 317.952c0-143.402 114.061-305.724 305.76-305.724 164.801 0 305.762 136.878 305.762 305.724Z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#envelope_svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 308.497,
  height: 316.34,
  x: 152.597,
  y: 137.439,
  fill: "#fff",
  rx: 4
}), /*#__PURE__*/React.createElement("path", {
  fill: "#58728C",
  d: "M105.538 480.28V336.119c0-2.877 2.947-4.813 5.588-3.671l197.333 85.347a4 4 0 0 0 3.237-.028l188.193-85.179c2.647-1.198 5.649.738 5.649 3.644V480.28a4 4 0 0 1-4 4h-392a4 4 0 0 1-4-4Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 10,
  d: "M151.694 350.064v-200.05a12.82 12.82 0 0 1 12.819-12.819h282.019a12.82 12.82 0 0 1 12.819 12.819v200.05"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 10,
  d: "m106.828 329.48 181.95 88.035a38.463 38.463 0 0 0 33.49 0l181.95-88.035"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 10,
  d: "m151.695 180.461-44.61 27.24h-.257v256.381a25.638 25.638 0 0 0 25.638 25.638H478.58a25.638 25.638 0 0 0 25.638-25.638V207.701h-.256l-44.61-27.24M221.366 137.196l64.095-39.21a38.459 38.459 0 0 1 40.156 0l64.095 39.21M228.608 201.291h76.915M228.608 252.566h153.829M228.608 303.844h153.829"
}))));
export default SvgEnvelope;